import axios from '@/http/axios/index.js'

export default {
    updateSettings(data){
        return axios.post('custom_dashboard/settings',data)
    },
    getUserData(){
        return axios.get('custom_dashboard/get_settings')
    }
}
  